export default __webpack_public_path__ + "static/media/Gotham-Medium.b4628314.woff2";